<template>
  <div class="account-bug">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="onLoad"
      v-if="accountBugList.length"
    >
      <div class="account-box">
        <div
          class="account-item"
          v-for="(item, i) in accountBugList"
          :key="i"
          @click="goToDetail(item)"
        >
          <div class="account-info">
            <img :src="item.logoUrl" alt="" />
            <div class="account-amount">
              <h1>{{ item.gameName }}</h1>
              <span class="account-desc">{{ item.title }}</span>

              <span class="total-sall"
                >累计消费：{{ item.totalMoney || 0 }}元</span
              >
            </div>
          </div>
          <span class="pay-status" :code="item.stateName">{{
            item.stateName
          }}</span>
          <span class="sall-price">￥{{ item.payMoney }}</span>
        </div>
      </div>
    </van-list>
    <div class="empty-account" v-else>
      <img src="@/assets/images/ic_default_three.png" alt="" />
      <span>暂无交易记录</span>
    </div>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      accountBugList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    finishedText() {
      if (this.accountBugList.length == 0) {
        return "";
      } else {
        return "暂无更多数据";
      }
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getBuyGameAccountList();
      this.accountBugList = [...this.accountBugList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 我的买入记录列表
     */
    async getBuyGameAccountList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/accounttx/accountBuy/getBuyGameAccountList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            searchParams: JSON.stringify({
              uuid: this.uuid,
            }),
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },
  },
};
</script>

<style lang="scss">
.account-bug {
  .empty-account {
    text-align: center;
    height: calc(100vh - 188px);
    margin-top: 188px;
    img {
      width: 260px;
      height: 160px;
      margin-bottom: 20px;
    }
    span {
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #7f7f7f;
      line-height: 33px;
    }
  }
  .account-box {
    padding: 15px;
    background: #f8f8f8;
    .account-item {
      background: #fff;
      padding: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 15px;
      position: relative;

      &:last-child {
        margin-bottom: 0;
      }

      .account-info {
        display: flex;
        align-items: flex-start;
        img {
          width: 132px;
          height: 132px;
          margin-right: 20px;
        }

        .account-amount {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #191919;
            margin-bottom: 4px;
            line-height: 40px;
            max-width: 390px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .account-desc {
            display: block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #7f7f7f;
            line-height: 37px;
            margin-bottom: 14px;
            max-width: 520px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .total-sall {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #7f7f7f;
            line-height: 37px;
          }
        }
      }
      .sall-price {
        position: absolute;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #191919;
        line-height: 45px;
        right: 20px;
      }
      .pay-status {
        position: absolute;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #191919;
        line-height: 45px;
        right: 20px;
        top: 20px;

        &[code="正在交易"] {
          color: #4ba700;
        }
        &[code="交易成功"] {
          color: #ff7a3e;
        }
        &[code="未支付"] {
          color: #f44444;
        }
        &[code="交易失败"] {
          color: #191919;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/tradeRecord/components/AccountBug.vue